import { WAVE_APP_ID } from "./queries.js";
export class WaveGraphQLError extends Error {
    errorType;
    reason;
    constructor(message, opts) {
        super(message);
        this.name = "WaveGraphQLError";
        this.errorType = opts?.errorType;
        this.reason = opts?.reason;
    }
    get isAuthOrPermissionFailure() {
        const errorType = this.errorType ?? "";
        const lower = this.message.toLowerCase();
        return (errorType === "Forbidden" ||
            errorType.includes("Unauthorized") ||
            lower.includes("forbidden") ||
            lower.includes("unauthorized") ||
            lower.includes("permessi"));
    }
}
export async function waveGraphQLFetch(opts) {
    const endpoint = opts.endpoint.trim();
    if (!endpoint)
        throw new WaveGraphQLError("Endpoint GraphQL mancante.");
    const res = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: opts.idToken,
            "X-Vida-AppId": WAVE_APP_ID,
        },
        body: JSON.stringify({
            query: opts.query,
            variables: opts.variables ?? {},
        }),
    });
    const text = await res.text();
    if (!res.ok) {
        throw new WaveGraphQLError(`HTTP ${res.status}: ${text.slice(0, 400)}`);
    }
    let json;
    try {
        json = JSON.parse(text);
    }
    catch {
        throw new WaveGraphQLError("Risposta non JSON");
    }
    const errors = json.errors;
    if (errors?.length) {
        const first = errors[0];
        const message = first.message ?? "Errore GraphQL";
        const errorType = first.errorType;
        const reason = first.errorInfo?.reason;
        throw new WaveGraphQLError(message, { errorType, reason });
    }
    const data = json.data;
    if (!data || !(opts.resultKey in data)) {
        throw new WaveGraphQLError(`Campo mancante: ${opts.resultKey}`);
    }
    const result = data[opts.resultKey];
    if (result === null) {
        return null;
    }
    if (result === undefined) {
        throw new WaveGraphQLError(`Campo mancante: ${opts.resultKey}`);
    }
    return result;
}
/** Parse ISO8601 dates from AppSync (with or without fractional seconds). */
export function parseAppSyncDate(value) {
    if (typeof value !== "string")
        return new Date().toISOString();
    return value;
}
export function graphqlHostFromEndpoint(endpoint) {
    try {
        return new URL(endpoint).host;
    }
    catch {
        return endpoint.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
    }
}
/** AppSync realtime URL must use ws/wss for browser WebSocket (Terraform may emit https). */
export function normalizeRealtimeWsUrl(endpoint) {
    let url = endpoint.trim().replace(/\/$/, "");
    if (url.startsWith("https://")) {
        url = `wss://${url.slice("https://".length)}`;
    }
    else if (url.startsWith("http://")) {
        url = `ws://${url.slice("http://".length)}`;
    }
    else if (!url.startsWith("wss://") && !url.startsWith("ws://")) {
        url = `wss://${url.replace(/^\/\//, "")}`;
    }
    if (!url.endsWith("/graphql")) {
        url = `${url}/graphql`;
    }
    return url;
}
export function realtimeEndpointFromGraphQL(graphqlEndpoint) {
    const trimmed = graphqlEndpoint.trim();
    if (trimmed.includes("appsync-realtime-api")) {
        return normalizeRealtimeWsUrl(trimmed);
    }
    return normalizeRealtimeWsUrl(trimmed.replace("appsync-api", "appsync-realtime-api"));
}
